// src/constants/dataTypes.js

export const dmEncryptionTypes = {
  AllDevices: 'All' ,
  NonEncrypted: 'Non Encrypted',
  Encrypted: 'Encrypted'
}



// export const fwdDataTypes = [
//   { value: 'DMReadout', label: 'Meter readout' },
//   { value: 'DMScan', label: 'Meter scan' },
//   { value: 'QnodeReadout', label: 'Network readout' },
//   { value: 'QnodeScan', label: 'Network scan' },
//   { value: 'CustomerReport', label: 'Report' }
// ];
